import {uniq} from 'ramda';

import {CompositionPreviewIssueResponseBody} from '@dms/api/shared';

/** IDs of the layers whose text the server render clipped; a layer overflowing both ways counts once. */
export const getOverflowLayerIds = (issues: CompositionPreviewIssueResponseBody[]) =>
  uniq(issues.map((issue) => issue.layerId));
